var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from "react";
import { GEO_ROUTE_PATH, HttpCode } from "@/constants";
import { useBrandUrl } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { fetchWithTimeout } from "@/utils";
import { useSnackbar } from "@gemini/ui";
import { useMapContext } from "../contexts/MapContext";
export const useTravelTimes = () => {
    const { viewport, setTravelTimes, setLoadingState } = useMapContext();
    const [isDistanceTooFar, setIsDistanceTooFar] = useState(false);
    const { add: addSnackbar } = useSnackbar();
    const { t } = useI18n();
    const geoSearchUrl = useBrandUrl({ endpoint: GEO_ROUTE_PATH });
    const calculateTravelTimes = useCallback((destination, onSuccess) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setTravelTimes([]);
        if (!destination)
            return;
        const { coordinates } = destination;
        const params = "unit=time&travel_modes=car&travel_modes=bike&travel_modes=walk&travel_modes=transit&include_geom=false&providers=targomo";
        try {
            setLoadingState("calculating_travel_times");
            const response = yield fetchWithTimeout(`${geoSearchUrl}?${params}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    sources: [
                        {
                            id: "source0",
                            coord: { lat: viewport.center[1], lng: viewport.center[0] },
                        },
                    ],
                    targets: [
                        {
                            id: "target0",
                            // @ts-ignore
                            coord: { lat: coordinates.lat, lng: coordinates.lng },
                        },
                    ],
                    date_time: new Date(),
                }),
            });
            if (response.status === HttpCode.REQUEST_TIMEOUT ||
                response.status === HttpCode.UNPROCESSABLE_CONTENT) {
                setLoadingState("failure");
                setIsDistanceTooFar(true);
            }
            else {
                const data = yield response.json();
                setLoadingState("success");
                setIsDistanceTooFar(false);
                setTravelTimes((_a = data.items) === null || _a === void 0 ? void 0 : _a.targomo);
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            }
        }
        catch (err) {
            addSnackbar({
                variant: "error",
                description: t("location.map.modal.travel_times.snackbar.error"),
            });
            setIsDistanceTooFar(false);
            setLoadingState("failure");
        }
    }), [
        addSnackbar,
        geoSearchUrl,
        setLoadingState,
        setTravelTimes,
        t,
        viewport.center,
    ]);
    return {
        calculateTravelTimes,
        isDistanceTooFar,
    };
};
